<template>
  <div>
    <navbarBox />
    <showdatainvitecomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import showdatainvitecomponents from "@/components/showdatainvitecomponents.vue";
export default {
  components: { showdatainvitecomponents, navbarBox },
};
</script>
